export function isWebView() {
  const ua = typeof window === 'undefined' ? useRequestHeaders()['user-agent'] : window.navigator.userAgent
  console.log('isWebView ua', ua)
  return ua?.includes('tantin')
}

export const inApp = typeof window === 'undefined' ? false : isWebView()
export const getInApp = isWebView
export const inUniApp = import.meta.client && window.navigator.userAgent.includes('uni-app')

export const inUniAppOrApp = inApp || inUniApp
